import { AxiosResponse } from 'axios';
import { apinewforms } from './api';

export const getSetorById = (id: number): Promise<AxiosResponse> =>
  apinewforms.get(`/core/setor/?orgao_id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
});